import { useEffect, useState } from 'react'
import Modal from '../Modal/Modal'
import './Popup.scss'

export default function Popup(){

    const [popup, setPopup] = useState(false)
    const [open, setOpen] = useState(false)

     useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVh(); // Встановлюємо при завантаженні
    window.addEventListener('resize', setVh); // Оновлюємо при зміні розміру

    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, []);

    useEffect((popup) => {
        setTimeout(() => setPopup(!popup), 4000)
    }, [])

    const changeModals = () => {
         setPopup(!popup)
        setOpen(!open)
    }
        const openModal = () => {
            setOpen(!open)
            
        }
    
    if(popup){
    return(
         <div className="Popup">
            <div className="wrapper">
                <div className="close"
                onClick={() => setPopup(!popup)}>X</div>
                <div className="img_block">
                    <img src="/hat.jpg" alt="student hat" />
                </div>
                <div className="content_block">
                    <h2>Швидко підберемо для вас курс та досвідченого викладача!</h2>
                    <div>
                        <button onClick={changeModals}>Почати</button>
                        
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
else if(open){
    return <Modal open={open} setOpen={openModal} />
}
}